import { render, staticRenderFns } from "./JobMaterials.vue?vue&type=template&id=6a5e0597&lang=pug&"
import script from "./JobMaterials.vue?vue&type=script&lang=js&"
export * from "./JobMaterials.vue?vue&type=script&lang=js&"
import style0 from "./JobMaterials.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports